import React, { useState, useEffect, useCallback } from "react";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { get, post, updateToken } from "../../../helpers/api_helper";
import CKEditorComponent from "../../../components/CKeditor/Ckeditor";
import { uploadPlugin } from "../../../helpers/common";
import useCheckPermission from "../../../hooks/useCheckPermission";

const Homepage = () => {
  const token = useSelector((state) => state.login.token);
  const [homepageData, setHomepageData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editorData, setEditorData] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchHome = useCallback(async () => {
    try {
      setLoading(true);
      const response = await get("/home/name/HOMEPAGE");
      if (response.success) {
        setHomepageData(response?.data || null);
        setEditorData(response?.data?.home || "");
      } else {
        console.log(response.message || "Failed to fetch Homepage");
        setHomepageData([]);
      }
    } catch (error) {
      console.log(error);
      setHomepageData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (token) {
      updateToken(token);
      fetchHome();
    }
  }, [token, fetchHome]);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = async () => {
    try {
      const response = await post(`/home/name/HOMEPAGE`, {
        home: editorData,
      });
      if (response?.success) {
        toast.success("Homepage updated successfully");
        fetchHome();
      } else {
        toast.error(response?.message || "Failed to update homepage");
      }
    } catch (error) {
      console.error("Error updating content:", error);
      toast.error("Error updating content");
    } finally {
      setIsEditing(false);
    }
  };

  return (
    <Container>
      <h5 className="my-2 fw-sbold">Homepage</h5>
      <Row>
        <Col lg="12">
          <div className="commonTable scrollable-table-container">
            <div className="d-flex align-items-center gap-10 btnWrpperGroup mt-3 pb-3">
              {useCheckPermission("home", "UPDATE") && <Button
                onClick={isEditing ? handleSave : handleEdit}
                className="d-inline-flex align-items-center justify-content-center commonBtn w-10"
              >
                {isEditing ? "Save" : "Edit"}
              </Button>}
            </div>
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100px" }}
              >
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            ) : (
              <div>
                {homepageData ? (
                  <div key={homepageData?._id}>
                    {isEditing ? (
                      <CKEditorComponent
                        content={editorData}
                        onChange={(data) => setEditorData(data)}
                        uploadPlugin={uploadPlugin}
                      />
                    ) : (
                      <div
                        dangerouslySetInnerHTML={{ __html: homepageData?.home }}
                      />
                    )}
                  </div>
                ) : (
                  <div>No homepage data found</div>
                )}
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Homepage;
